import getCompany from "./getCompany";

const maxWeight = type => {
  if (type === 1) {
    return { value: 100, message: "حداکثر وزن 100 کیلو گرم" };
  }

  if (getCompany().selected?.componyTypeId === 11) {
    return { value: 500, message: "حداکثر وزن 500 کیلو گرم" };
  } else {
    return { value: 20, message: "حداکثر وزن 20 کیلو گرم" };
  }
};

export default maxWeight;
